var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-code-menu relative"},[_c('p',{staticClass:"mt-16px help-color"},[_vm._v(_vm._s(_vm.$t('menu.codeTip')))]),_vm._v(" "),_c('remove-btn',{staticClass:"mt-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }